/* ew-pro-landing.js — landing Profesionales: scroll-reveal + montaje del form SnapB2B.
   Asset externo a proposito (los <script> inline de seccion se corrompen al renderizar). */

/* ---- Form SnapB2B embebido (progressive enhancement) ----
   La app solo inyecta su bundle en /pages/formulario-profesionales, asi que lo
   traemos de alli en cliente (mismo origen): config fresca + scripts con version
   actual. Si el montaje falla, el formulario nativo de abajo queda como respaldo.

   SOLO se monta en el portal de Profesionales. El resto de paginas que reutilizan
   esta seccion (Colaboraciones / hosteleria, etc.) se quedan con el formulario
   nativo: mas corto, en el idioma de la pagina y sin el titulo "Profesionales",
   que ahi confundia al visitante. Para permitirlo en otra pagina, anade su ruta
   a SNAP_PAGES. */
(function () {
  'use strict';
  var SNAP_PAGES = ['/pages/profesionales'];

  var path = location.pathname.replace(/\/+$/, '');
  var onSnapPage = false;
  for (var p = 0; p < SNAP_PAGES.length; p++) {
    // Comparacion por final de ruta para que valga con prefijo de idioma (/es/pages/...).
    if (path === SNAP_PAGES[p] || path.slice(-SNAP_PAGES[p].length) === SNAP_PAGES[p]) {
      onSnapPage = true;
      break;
    }
  }
  if (!onSnapPage) return;

  var mount = document.getElementById('snap-b2b-registration-form');
  var native = document.querySelector('.pl-regform');
  if (!mount || !native || !window.fetch) return;

  fetch('/pages/formulario-profesionales', { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
    .then(function (html) {
      var scripts = html.match(/<script\b[^>]*>[\s\S]*?<\/script>/gi) || [];
      var cfg = null;
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].indexOf('snapB2bRegistrationFormData') !== -1) {
          cfg = scripts[i].replace(/^<script\b[^>]*>/i, '').replace(/<\/script>$/i, '');
          break;
        }
      }
      var srcs = [];
      var re = /<script\b[^>]*\bsrc="([^"]+)"[^>]*>/gi, mm;
      while ((mm = re.exec(html))) {
        var s = mm[1];
        if (/react(-dom)?@18\/umd|registration-form-react\.js/.test(s) && srcs.indexOf(s) === -1) srcs.push(s);
      }
      var css = (html.match(/href="([^"]*snap-b2b[^"]*\/assets\/style\.css[^"]*)"/) || [])[1];
      if (!cfg || srcs.length < 3) throw new Error('bundle not found');

      if (css) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = css;
        document.head.appendChild(l);
      }
      new Function(cfg)();

      var loadNext = function (idx) {
        if (idx >= srcs.length) return;
        var sc = document.createElement('script');
        sc.src = srcs[idx];
        sc.onload = function () { loadNext(idx + 1); };
        document.head.appendChild(sc);
      };
      loadNext(0);

      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (mount.children.length > 0 && mount.textContent.replace(/\s/g, '') !== '') {
          clearInterval(t);
          mount.hidden = false;
          native.style.display = 'none';
        } else if (tries > 48) {
          clearInterval(t);
        }
      }, 250);
    })
    .catch(function () { /* respaldo: se queda el formulario nativo */ });
})();

(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('js-plrv')) return;

  // Un observador vivo SIEMPRE entrega un callback inicial para lo observado,
  // aunque este fuera de pantalla: "¿ha respondido?" es el test correcto,
  // no "¿se ha revelado algo?".
  var ioAnswered = false;
  var io = new IntersectionObserver(function (entries) {
    ioAnswered = true;
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.plrv').forEach(function (el, i) {
    var prev = el.previousElementSibling;
    if (prev && prev.classList.contains('plrv')) el.style.transitionDelay = (i % 4) * 0.09 + 's';
    io.observe(el);
  });

  // Failsafe: nunca dejar contenido en opacity:0 si el observador esta muerto.
  // Armar el timer solo con la pestana visible (Chrome congela IO en background).
  var armFailsafe = function () {
    setTimeout(function () {
      if (!ioAnswered) root.classList.remove('js-plrv');
    }, 2500);
  };
  if (document.visibilityState === 'visible') {
    armFailsafe();
  } else {
    document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', once);
      armFailsafe();
    });
  }
})();
